import { Injectable } from '@angular/core';
import { Qualifier } from 'src/app/types/qualifier';
import { CastingLinkValue } from 'src/app/components/att-casting-view/formats/casting-link/casting-link.component';
import { CastingMode, CastingValue } from 'src/app/components/att-casting-view/att-casting-view.component';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';
import { EnvService } from 'src/app/env.service';
import { environment } from 'src/environments/environment';

export type MediaQualifierVal = {
  baseURL: string;
  mediaId: number;
  remainder: string;
  fileName: string;
  fileExt: string;
  url?: string;
}


@Injectable({
  providedIn: 'root'
})
export class MediaQualifierService implements Qualifier {
  static supportedStats = ['first', 'last'];

  static FromString(value: string): MediaQualifierVal {
    const mediaBase = 'https://media.simplelayers.com/';
    if (value.indexOf('feature_image') > -1) {
      return null;
    }
    if (value.length < mediaBase.length) {
      return null;
    }
    const remainder = value.substr(mediaBase.length).replace(/\/\//g, '/');

    const valInfo = remainder.split('/');
    if (remainder.substr(-1, 1) === '/') {
      valInfo.pop();
    }

    if (valInfo.length === 0) {
      return null;
    }
    const mediaId = Number.parseInt(valInfo.shift(), 10);
    const fileName = valInfo.length > 0 ? valInfo.pop() : '';
    const fileInfo = fileName.split('.');
    const fileExt = fileInfo.length > 1 ? fileInfo.pop() : '';

    const mediaValue = {
      baseURL: mediaBase,
      mediaId: (mediaId),
      fileName: (fileName),
      fileExt: (fileExt),
      remainder: (remainder)
    }
    MediaQualifierService.ToString(mediaValue);
    return mediaValue;

  }
  static ToFeatureImageString(value: string): string {
    if (value.substr(-1, 1) !== '/') {
      value += '/';
    }
    switch (environment.envName) {
      case 'dev-local':
      case 'dev':
        return value + 'context:dev/'
        break;
      case 'staging':
        return value + 'context:staging/'
        break;
      default:
      case 'prod':
        return value;
        break;
    }
  }
  static ToString(value: MediaQualifierVal): string {
    let retValue = '';
    retValue = value.baseURL;
    switch (environment.envName) {
      case 'dev-local':
      case 'dev':
        retValue += 'context:dev/'
        break;
      case 'staging':
        retValue += 'context:staging/'
        break;
      default:
      case 'prod':
        break;
    }
    // retValue += value.mediaId + '/';
    retValue += value.remainder;
    value.url = retValue;
    return retValue;

  }

  public static GetDisplayValue(attribute: AttributeInfo, castingMode: CastingMode, val: any): string {

    if (!attribute.casting) {
      return val;
    }
    if (!attribute.casting[castingMode]) {
      return val;
    }
    const casting: CastingValue = attribute.casting[castingMode] as CastingValue;
    switch (attribute.type) {
      case 'text':
      case 'string':
        return val;
      default:
        return MediaQualifierService.ToHyperLink(attribute, castingMode, val);
    }
  }
  public static GetTextExportValue(attribute: AttributeInfo, castingMode: CastingMode, val: any): string {
    if ([undefined, null].indexOf(val) > -1) {
      return '';
    }
    return val;
  }
  public static GetNativeValue(attribute: AttributeInfo, _castingMode: CastingMode, value: any): any {
    return MediaQualifierService.FromString(value);
  }
  public static ToHyperLink(attribute, castingMode: CastingMode, val: any) {

    if (val === null) {
      return val;
    }
    if (val.indexOf('https://media.simplelayers.com/') === -1) {
      return val;
    }
    if (val.indexOf('https://media.simplelayers.com/feature_img/') === 0) {
      const value = MediaQualifierService.ToFeatureImageString(val);
      return `<a class="media-qualifier-link" href="preview-image" onClick="event.preventDefault();document.body.dispatchEvent(new CustomEvent('preview-media',{detail:{url:'${value}'}}));return false;">View Image</a><span> or </span><a href="${value}" target="_blank">Download File</a>`;
    }
    const info = MediaQualifierService.FromString(val);

    switch (info.fileExt.toLowerCase()) {
      case 'png':
      case 'jpeg':
      case 'jpg':
      case 'gif':
        const infoString = JSON.stringify(info);
        return `<a class="media-qualifier-link" href="preview-image" onClick="event.preventDefault();document.body.dispatchEvent(new CustomEvent('preview-media',{detail:{url:'${info.url}'}}));return false;">View Image</a><span> or </span><a href="${info.url}" target="_blank">Download File</a>`;
    }
    return MediaQualifierService.ToUnCastLink(val);

  }

  public static ToUnCastLink(val: any) {
    const matches = ('' + val as string).match(/https:\/\/media\.simplelayers\.com\/(\d+)\/(.*)/)
    if (matches.length === 3) {
      if (matches[2] === '') {
        return '<s>' + val + '</s>';
      }
    }

    return '<a href="' + val + '" target="_blank">click to download</a>';
  }
  static SupportsStat(statName: string) {
    return MediaQualifierService.supportedStats.indexOf[statName];
  }
  constructor() { }
}
